import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useCampaignContribution from '@hooks/useCampaignContribution'
import useCampaignContributions from '@hooks/useCampaignContributions'

import defaultRequestOptions from '@sections/Client/packs/Campaign/defaultRequestOptions'

import type { CampaignModel } from '@models/types'

import CampaignContribution from './CampaignContribution'

interface CampaignContributionsProps {
  campaign: CampaignModel,
}

const CampaignContributions = (props: CampaignContributionsProps) => {
  const { campaign } = props

  const campaignContributionsPayload = useCampaignContributions({
    filters: {
      campaign_id: campaign.id,
    },
    performHttpRequests: !!campaign.id,
    requestOptions: defaultRequestOptions.campaignContribution,
  })

  const {
    filteredCampaignContributions,
    hasFilteredCampaignContributions,
    loading,
  } = campaignContributionsPayload

  const campaignContributionPayload = useCampaignContribution({ campaign_id: campaign.id })
  const {
    callbacks: {
      createOrEditCampaignContribution,
    },
  } = campaignContributionPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        // @ts-expect-error TS2322
        <DashboardModule.Link href={`#/campaigns/${campaign.id}/edit/accounting`}>
          Manage
        </DashboardModule.Link>
      )}
      loading={loading}
      title="Contributions"
    >
      {!loading && !hasFilteredCampaignContributions && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Contributions Added
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Click the button below to add one.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {filteredCampaignContributions.map(campaignContribution => (
        <CampaignContribution
          key={campaignContribution.id}
          campaignContribution={campaignContribution}
        />
      ))}

      <DashboardModule.Footer
        boxProps={{ borderTop: hasFilteredCampaignContributions || loading ? 'none' : '1px solid' }}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          marginLeft="auto"
          onClick={() => createOrEditCampaignContribution()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Contribution
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default CampaignContributions
